import { useState } from "react";

function DiaryCard({ video, index }) {
  const [playing, setPlaying] = useState(false);
  return (
    <article data-testid={`diary-card-${video.id}`} className="group">
      <div className="yt-aspect img-zoom border border-[rgba(26,26,26,0.12)] bg-[#1a1a1a]">
        {playing ? (
          <iframe
            data-testid={`diary-iframe-${video.id}`}
            src={`https://www.youtube.com/embed/${video.youtube_id}?autoplay=1&rel=0`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <>
            <img
              className="yt-thumb"
              src={`https://img.youtube.com/vi/${video.youtube_id}/maxresdefault.jpg`}
              alt={video.title}
              onLoad={(e) => {
                if (e.currentTarget.naturalWidth < 320 && !e.currentTarget.dataset.fb) {
                  e.currentTarget.dataset.fb = "1";
                  e.currentTarget.src = `https://img.youtube.com/vi/${video.youtube_id}/sddefault.jpg`;
                } else if (e.currentTarget.naturalWidth < 320 && e.currentTarget.dataset.fb === "1") {
                  e.currentTarget.dataset.fb = "2";
                  e.currentTarget.src = `https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg`;
                }
              }}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = `https://img.youtube.com/vi/${video.youtube_id}/mqdefault.jpg`;
              }}
            />
            <button
              data-testid={`diary-play-${video.id}`}
              className="thumb-play"
              onClick={() => setPlaying(true)}
              aria-label={`Play ${video.title}`}
            >
              <div className="play-circle">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </button>
          </>
        )}
      </div>

      <div className="mt-4 flex items-baseline justify-between gap-4">
        <h3 className="font-serif-display text-xl md:text-2xl text-[#1A1A1A] group-hover:text-[#A68661] transition-colors">
          {video.title}
        </h3>
        <span className="font-mono-overline text-[#1A1A1A]/50 whitespace-nowrap">{video.year}</span>
      </div>
    </article>
  );
}

export default function VisualDiaries({ items = [] }) {
  if (!items.length) return null;
  return (
    <section
      id="diaries"
      data-testid="diaries-section"
      className="relative bg-[#F7F7F5] text-[#1A1A1A] py-14 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-8 flex items-center gap-3">
          <span className="w-10 h-px bg-[#1A1A1A]" />
          <span className="font-mono-overline">04 — Visual diaries</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {items.map((v, i) => (
            <DiaryCard key={v.id} video={v} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
